module.exports = __webpack_public_path__ + "img/boxed_meals_1.5159a97c.jpg";